import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { graphql, StaticQuery } from 'gatsby'
import NewsletterForm from './NewsletterForm'
import FooterMenu from './FooterMenu'
import WeAccept from './WeAccept'

class Footer extends React.Component {
  _handleWaypointEnter = () => {
    const element = document.getElementById('freeshipping')
    if (typeof element !== 'undefined' && element != null) {
      element.classList.add('fade')
    }
  }

  _handleWaypointLeave = () => {
    const element = document.getElementById('freeshipping')
    if (typeof element !== 'undefined' && element != null) {
      element.classList.remove('fade')
    }
  }

  render() {
    const FooterWrap = styled.footer`
      ${tw`w-full py-12 px-6 md:py-16 md:pb-4 md:px-10 bg-colekt-black text-almost-white`}
    `

    const Copyright = styled.div`
      ${tw`text-xs opacity-75 font-mono tracking-wider md:order-1`}
    `

    const FooterInnerWrap = styled.div`
      ${tw`md:flex md:justify-between`}
    `

    const Extras = styled.div`
      ${tw`md:flex md:justify-between items-end`}
    `

    return (
      <FooterWrap className="blackonwhite">
        <FooterInnerWrap>
          <NewsletterForm />
          <FooterMenu />
        </FooterInnerWrap>
        <Extras>
          <WeAccept />
          <StaticQuery
            query={graphql`
              query {
                wp {
                  globalSettings {
                    footer {
                      copyright
                    }
                  }
                }
              }
            `}
            render={(data) => {
              const { copyright } = data.wp.globalSettings.footer
              return (
                <Copyright>
                  © {new Date().getFullYear()} {copyright || 'Colekt'}. All rights reserved.
                </Copyright>
              )
            }}
          />
        </Extras>
      </FooterWrap>
    )
  }
}
export default Footer
